import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import AccountOutline from '@monofront/design-system/visuals/Icons/Old/AccountOutline';
import React from 'react';

interface IGoToLoginPageButton {
  label?: string;
  isButton?: boolean;
  UNSAFE_className?: string;
}

const GoToLoginPageButton: React.FC<IGoToLoginPageButton> = ({
  label,
  isButton,
  UNSAFE_className = '',
}) => {
  const router = useRouter();
  const tAccount = useTranslations('Account');

  const title = label || tAccount('logIn');

  return (
    <>
      {isButton ? (
        <Link
          href={`/account/login${
            router.pathname !== '/account/login' ? `?next=${router.asPath}` : ``
          }`}
          className={`tw-lf-button tw-lf-button-primary tw-lf-button-md tw-inline-flex ${UNSAFE_className}`}
          rel="nofollow"
          data-testid="GoToLoginPageButton-Button-account-login"
        >
          {title}
        </Link>
      ) : (
        <Link
          href={`/account/login${
            router.pathname !== '/account/login' ? `?next=${router.asPath}` : ``
          }`}
          className={`link-account ${UNSAFE_className}`}
          rel="nofollow"
          data-testid="GoToLoginPageButton-go-to-account-login"
        >
          <span className="tw-hidden desktop:tw-block">{title}</span>
          <span className="tw-flex desktop:tw-hidden">
            <AccountOutline width={24} height={24} />
          </span>
        </Link>
      )}
      <style jsx>{`
        :global(.link-account) {
          color: var(--black);
          font-size: var(--font-size-2);
          font-weight: var(--font-weight-base);
          transition: all 0.3s ease;
          white-space: nowrap;
          text-decoration: underline;
        }

        :global(.link-account:hover) {
          opacity: var(--opacity-link-hover);
        }
      `}</style>
    </>
  );
};

export default GoToLoginPageButton;
